<template>
  <b-img
    class="logo"
    :src="logoSrc"
    :width="size"
    :height="size"
  />
</template>
<script>
import logo from '@/views/logics/components/logo'

export default {
  mixins: [logo],

}
</script>

<style scoped>

</style>
